// extracted by mini-css-extract-plugin
module.exports = {"cardListItem":"BenefitDetailsItem_cardListItem__24eld","textButton":"BenefitDetailsItem_textButton__3R0v8"};